// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-icon {
  font-size: 22px !important;
  margin-left: 5px;
}

.actions {
  height: 35px;
  align-items: center;
  padding-right: 10px;
}

.link-text {
  text-overflow: ellipsis;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 12px !important;
  letter-spacing: 0.254903px;
  color: var(--theme-main-color, #055C8D);
  vertical-align: middle;
}

.link-text:hover {
  color: var(--theme-main-darker-color, #055C8D);
}

.v-align-middle {
  vertical-align: middle;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
